<template>
<div>
  <span>{{ item.properties.label }}</span>
</div>
</template>

<script>
export default {
  name: 'AdresseTemplate',
  props: {
    item: {
      required: true
    },
    searchText: {
      required: true
    }
  }
}
</script>
